import PreviewSection from '../../PreviewSection'

export default function CostHTMLPreviewHeaderSection() {}

CostHTMLPreviewHeaderSection.prototype = new PreviewSection();

CostHTMLPreviewHeaderSection.prototype.init = function( columnsStrategy )
{
    PreviewSection.prototype.init.call( this );
    this.columnsStrategy = columnsStrategy;
    return this;
};

CostHTMLPreviewHeaderSection.prototype.addRows = function( tBody )
{
    var twoRowsInHeader = this.columnsStrategy.areThereTwoRowsInHeader();

    var firstRow = this.createRow( "headerRow firstHeaderRow " + (twoRowsInHeader ? "lowFirstRow" : "") );
    this.addCell( firstRow, this.message( "report.cost_items" ), "costItems", 1, 3 );
    this.columnsStrategy.addFirstHeaderRowDataCells( firstRow );
    this.addRow( tBody, firstRow );

    var secondRow = this.createRow( "headerRow secondHeaderRow" );
    this.columnsStrategy.addSecondHeaderRowDataCells( secondRow );
    this.addRow( tBody, secondRow );

    var thirdRow = this.createRow( "headerRow thirdHeaderRow " + (twoRowsInHeader ? "highThirdRow" : "") );
    this.columnsStrategy.addThirdHeaderRowDataCells( thirdRow );
    this.addRow( tBody, thirdRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewHeaderSection.js